const accounts = {
    totalLoadSuggested: 20, // allow get max 20 accounts from Api
    defaultShowSuggested: 10,
    defaultShowFollowed: 5,
};

export default accounts;
